import React from 'react';
import {
  CheckoutOrderReviewCustomerMolecule,
  CheckoutTabHeaderMolecule,
} from '../../molecules';
import { PatientStepsHeader } from '../../../data/pages/checkout/patient-steps.data';
import { ResponsiveSizes, Route } from '../../../enums';
import { PatientActionsOrganism } from '../patient-actions';
import { useSelector } from 'react-redux';
import { StoreState } from '../../../services';
import { PatientOrderSummaryOrganism } from '../patient-order-summary';
import { useResponsiveQuery } from '../../../utils';
import { PatientSubscriptionSummaryOrganism } from '../patient-subscription-summary';
import { PromoBoxOrganism } from '../promo-box';
import { cartPromoBox } from '../../../data/pages/cart/cart-promo-box';
import { CheckoutButtons } from '../../../enums/pages/checkout/checkout-buttons';
import { usePatientEffect } from '../../../effects';

export const PatientOrderReviewOrganism = () => {
  const isBreakpoint = useResponsiveQuery(ResponsiveSizes.CHECKOUT_DESKTOP);
  const { cart, includesDrops, includesTrial } = useSelector(
    (state: StoreState) => state.orders.cart
  );
  const { patientState, pageActions } = usePatientEffect('review');

  return (
    <section data-cy="checkout-address-step-organism">
      <div className="bg-white py-5 lg:py-0 border-b border-waldo-blue">
        <CheckoutTabHeaderMolecule
          title={PatientStepsHeader.DOCTOR}
          editable={true}
          editLink={Route.PATIENT_DOCTOR}
        />
        <CheckoutTabHeaderMolecule
          title={PatientStepsHeader.REGISTER}
          editable={true}
        />
        <CheckoutTabHeaderMolecule
          title={PatientStepsHeader.PLAN}
          editable={true}
          editLink={Route.PATIENT_PLAN}
        />
        <CheckoutTabHeaderMolecule
          title={PatientStepsHeader.PRESCRIPTION}
          editable={true}
          editLink={Route.PATIENT_PRESCRIPTION}
        />
        <CheckoutTabHeaderMolecule
          title={PatientStepsHeader.SHIPPING}
          editable={true}
          editLink={Route.PATIENT_SHIPPING}
        />
        <div className="py-8 w-11/12 lg:w-full mx-auto">
          <h1 className="text-tabTitle font-normal font-waldo-regular no-underline">
            {PatientStepsHeader.REVIEW}
          </h1>
          <div className="mt-5 bg-waldo-light-blue p-5 mx-auto lg:mx-0 rounded-lg">
            <p className="text-lg font-semibold mb-5">Account details</p>
            <div className="py-2.5 pl-5 pr-0 bg-waldo-lighter-blue rounded-lg">
              <CheckoutOrderReviewCustomerMolecule
                title="Email"
                click={pageActions.setOpenRegistration}
              >
                <p className="text-footer font-light leading-6">
                  {' '}
                  {patientState.formData.registration.email}
                </p>
              </CheckoutOrderReviewCustomerMolecule>

              <CheckoutOrderReviewCustomerMolecule
                title="Shipping"
                click={pageActions.setOpenShipping}
              >
                <p>
                  {patientState.formData.address.shippingAddress?.firstName}{' '}
                  {patientState.formData.address.shippingAddress?.lastName}
                  <br />
                  {patientState.formData.address.shippingAddress?.company}{' '}
                  {patientState.formData.address.shippingAddress?.line1}{' '}
                  {patientState.formData.address.shippingAddress?.line2},{' '}
                  {patientState.formData.address.shippingAddress?.city}{' '}
                  {patientState.formData.address.shippingAddress?.state}{' '}
                  {patientState.formData.address.shippingAddress?.country} ,
                  {patientState.formData.address.shippingAddress?.postalCode}
                  <br />
                  {patientState.formData.address.shippingAddress?.phone}
                </p>
              </CheckoutOrderReviewCustomerMolecule>
              <CheckoutOrderReviewCustomerMolecule
                title="Billing"
                click={pageActions.setOpenShipping}
              >
                <p>
                  {patientState.formData.address.billingAddress?.company}{' '}
                  {patientState.formData.address.billingAddress?.line1}{' '}
                  {patientState.formData.address.billingAddress?.line2},{' '}
                  {patientState.formData.address.billingAddress?.city}{' '}
                  {patientState.formData.address.billingAddress?.state}{' '}
                  {patientState.formData.address.billingAddress?.country} ,
                  {patientState.formData.address.billingAddress?.postalCode}
                  <br />
                  {patientState.formData.address.billingAddress?.phone}
                </p>
              </CheckoutOrderReviewCustomerMolecule>
            </div>
          </div>
          {isBreakpoint && (
            <>
              <PatientOrderSummaryOrganism />
              {!includesDrops && (
                <PromoBoxOrganism
                  title={cartPromoBox.title}
                  subtitle={cartPromoBox.subtitle}
                  description={cartPromoBox.description}
                  imageUrl={cartPromoBox.imageUrl}
                  buttonText={cartPromoBox.buttonText}
                />
              )}
              {includesTrial && cart && (
                <PatientSubscriptionSummaryOrganism cart={cart} />
              )}
            </>
          )}
        </div>
        <PatientActionsOrganism />
        <div className="pt-2.5 pb-8 w-11/12 lg:w-full mx-auto">
          <div className="flex flex-col items-center w-full py-5 lg:py-1">
            <button
              className="button btn-third-cta w-full md:w-[243px] text-uppercase font-waldo-header font-medium text-base"
              type="submit"
              onClick={pageActions.setOpenPayment}
            >
              <>{CheckoutButtons.CONTINUE_PAYMENT}</>
            </button>
          </div>
        </div>
      </div>
      <div className="w-11/12 lg:w-full mx-auto">
        <CheckoutTabHeaderMolecule
          title={PatientStepsHeader.PAYMENT}
          displayBorder={false}
        />
      </div>
    </section>
  );
};
